import { once } from "@utils/general";

import {
    TOOL_STORE_LOCATOR_CONTEXT,
    TOOL_STORE_LOCATOR_STEPS,
} from "@services/tracking/trackers/tools/storeLocator/config";
import { trackStoreLocatorToolStep } from "@services/tracking/trackers/tools/storeLocator/tracker";
import { EventTypes } from "@services/tracking/types/eventTypes";
import { StepVariables } from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

const trackStoreLocatorStepStarted = once(() => {
    trackStoreLocatorToolStep(
        EventTypes.ToolStep,
        TOOL_STORE_LOCATOR_STEPS.start,
        TOOL_STORE_LOCATOR_CONTEXT,
    );
});

const trackStoreLocatorStepSubmitted = (storeLocatorResult: any) => {
    if (!storeLocatorResult) return;

    const step: StepVariables = {
        ...TOOL_STORE_LOCATOR_STEPS.submit,
        placement: `winkels:${storeLocatorResult.storeName}`,
        result: {
            zip: storeLocatorResult.zipCode,
            storeId: storeLocatorResult.storeId,
        },
    };

    trackStoreLocatorToolStep(
        EventTypes.ToolStep,
        step,
        TOOL_STORE_LOCATOR_CONTEXT,
    );
};

export { trackStoreLocatorStepSubmitted, trackStoreLocatorStepStarted };
